import {createMutation} from 'react-query-kit'

import {apiConvertToIssue} from '../../../api/memex-items/api-convert-to-issue'
import {useSetMemexItemData} from '../use-set-memex-item-data'

const useApiConvertToIssueMutation = createMutation({
  mutationFn: apiConvertToIssue,
})
export const useConvertToIssueMutation = () => {
  const {setItemData} = useSetMemexItemData()
  return useApiConvertToIssueMutation({
    onSuccess: response => {
      setItemData(response.memexProjectItem)
    },
  })
}
